import { render, staticRenderFns } from "./dietRecordList-dialog.vue?vue&type=template&id=ba72e7da&scoped=true"
import script from "./dietRecordList-dialog.vue?vue&type=script&lang=js"
export * from "./dietRecordList-dialog.vue?vue&type=script&lang=js"
import style0 from "./dietRecordList-dialog.vue?vue&type=style&index=0&id=ba72e7da&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba72e7da",
  null
  
)

export default component.exports